
import {VIcon, VBtn} from 'vuetify/lib'
import VTable from '@/vuetify_custom/v-table/v3'
import ViewerItem from '@/views/components/viewer/item_v1.vue';
import Attachments from '@/views/components/file/attachments.vue'
import {getPlacingAdsRecordDetailApi, postPlacingAdsVasRecordDeleteApi} from '../service'
import { service_in_types } from '../../fields'
export default {
    props: {
        value: {
            type:Object
        },
        detail:{
            type:Object,
        },
        showPl: {
            type:Boolean
        },
        adsArr: {
            type: Array
        },
        showButtonD: {
            type: Boolean
        }
    },
    data() {
        return {
            list: [],
            loading:false,
            my_value: this.value
        }
    },
    computed: {
        table_fields_proxy() {
            if (!this.showPl) {
                return this.table_fields
            }
            return [this.table_fields[0],
            {
                text: '选择',
                align: 'center',
                value: 'xuanze',
                width: 70,

            },
            ...this.table_fields.slice(1)]
        },
        table_fields() {
            return [
                {
                    text: '加成服务编号',
                    align: 'center',
                    value: 'uid',
                    width: 120,
                }, 
                {
                    text: '服务时间',
                    align: 'center',
                    value: 'service_date',
                    width: 120,
                },
                // {
                //     text: '投放类型',
                //     align: 'center',
                //     value: 'service_type',
                //     width: 120,
                //     type: 'list_field',
                //     item_key: 'value',
                //     item_text: 'label',
                //     items: service_in_types
                // },
                {
                    text: '服务类型',
                    align: 'center',
                    value: 'service_type',
                    width: 120,
                    type: 'list_field',
                    item_key: 'value',
                    item_text: 'label',
                    items: service_in_types
                },
                {
                    text: '服务金额',
                    align: 'center',
                    value: 'total_price',
                    type: 'money_field',
                    width: 120,
                },
                {
                    text: '合同编号',
                    align: 'center',
                    value: 'placing_ads_contract',
                    width: 120,
                    render:(_, t) => {
                        if (!t.placing_ads_contract || !t.placing_ads_contract.contract_id) {
                            return '-'
                        }
                       
                        return <div>
                        <ViewerItem type={t.placing_ads_contract.contract_type} modelId={t.placing_ads_contract.contract_id || 0}>
                           <a>
                             {t.placing_ads_contract.contract_uid}
                           </a> 
                        </ViewerItem>
                    </div>
                    } 
                },
                {
                    text: '付款单',
                    align: 'center',
                    value: 'expense_groups_fk',
                    width: 120,
                    render:(_, t) => {
                        if (!t.expense_groups_fk || !t.expense_groups_fk.length) {
                            return '-'
                        }
                       
                        return <div>
                            {t.expense_groups_fk.map(i => {
                                return <ViewerItem type="ExpenseGroup" modelId={i.id || 0}>
                                <a>
                                  {i.uid}
                                </a> 
                             </ViewerItem>
                            })}
                  
                    </div>
                    } 
                },
                {
                    text: '账单',
                    align: 'center',
                    value: 'expense_groups_zd',
                    width: 120,
                    render:(_, t) => {
                        if (!t.expense_groups_zd || !t.expense_groups_zd.length) {
                            return '-'
                        }
                       
                        return <div>
                            {t.expense_groups_zd.map(i => {
                                return <ViewerItem type="ExpenseGroup" modelId={i.id || 0}>
                                <a>
                                  {i.uid}
                                </a> 
                             </ViewerItem>
                            })}
                  
                    </div>
                    } 
                },
                {
                    text: '附件',
                    align: 'center',
                    value: 'bfiles',
                    width: 120,
                    render:(_, t) => {
                        if (!t.bfiles || !t.bfiles.length) {
                            return '-'
                        }
                        return <div>
                        <Attachments files={t.bfiles}/>
                    </div>
                    } 
                },
                {
                    text: '操作',
                    align: 'center',
                    value: 'action',
                    fixed: 'right',
                    width: 120,
                    type: 'button_s_field',
                    b_text: '操作',
                    z_index:2,
                    getButtons:({buttons}) => {
                       
                        return buttons && buttons.filter(item => {
                            if (item.show === undefined) {
                                return true
                            }
                            return item.show
                        })
                    },
                    callBack:({key}, target) => {
                       // postPlacingAdsVasRecordDeleteApi
                       switch (key) {
                           case 'del':
                                this.$vModal.confirm({
                                    title:'提示',
                                    content: '你确定要删除此条加成服务吗？',
                                    loading:true,
                                    onOk:({
                                      destroy,
                                      stopLoading
                                    }) => {
                                        postPlacingAdsVasRecordDeleteApi({id: target.id}).then(() => {
                                        this.$Message.success({
                                          content: '操作成功!'
                                        });
                                        this.getData()
                            
                                      }).finally(() => {
                                        destroy()
                                        stopLoading()
                                      })
                                    }
                                })
                               break;
                       case 'editProxy':
                                this.$emit('edit', this.detail, target)
                        break
                        case 'fkProxy':
                        case 'zdProxy':
                            this.$emit('handle', {
                                key,
                                target,
                                parent_detail: this.detail,
                            })
                            break
                        default:
                               break;
                       }
                       
                    },
                    buttons: [
                      {
                        text: '编辑',
                        key: 'editProxy',
                        color: 'primary',
                        small: true,
                        show: this.showButtonD
                      },
                      {
                        text: '付款申请',
                        key: 'fkProxy',
                        color: 'primary',
                        small: true,
                      },
                      {
                        text: '生成账单',
                        key: 'zdProxy',
                        color: 'primary',
                        small: true,
                      },
                      {
                        text: '废弃',
                        key: 'del',
                        color: 'primary',
                        small: true,
                        show: this.showButtonD
                      }
                      
                    //   {
                    //     text: '未完结',
                    //     key: 'feiqi',
                    //     color: 'primary',
                    //     small: true,
            
                    //   },
                    ]
                }
               
               
            ]
        }
    },
    watch: {
        value(val) {
            this.my_value = val  
        },
        my_value(val) {
            this.$emit('input', val)
        }
    },
    mounted() {
     this.getData()
    },
    methods: {
        getData() {
            this.loading = true
            getPlacingAdsRecordDetailApi({id: this.detail.id}).then(res => {
                this.$emit('getData', res)
                this.list = res.placing_ads_vas_records || []
            }).finally(() => {
                this.loading = false
            })
        }
    },
    render() {
        return <div>
            <p style="margin: 10px 20px;font-weight:bold">加成服务</p>
            <VTable 
                loading={this.loading} 
                headers={this.table_fields_proxy} 
                desserts={this.list}
                scopedSlots = {{
                    xuanze: (_, item) => {
                        return <div>
                            <VBtn 
                                fab
                                depressed
                                x-small
                            
                                on={{
                                 click:() => {
                                
                                     this.$emit('ChangePlItem', item, 'ads_vas_record_ids')
                                 }
                                }}
                            >
                                {this.adsArr.includes(item.id) && <VIcon color="primary">
                                    mdi-checkbox-marked
                                </VIcon>}
                                {!this.adsArr.includes(item.id) && <VIcon>
                                    mdi-checkbox-blank-outline
                                </VIcon>}
                            </VBtn>
                        </div>
                    }
                }}
            />
        </div> 
    }
}